<div class="grid-container margin-top">
  <form [formGroup]="form">
    <div class="grid-x">
      <div class="cell small-6 medium-2 large-2 text-align-right padding-right">
        From Date:<span class="bold" [ngClass]="{ 'red' : !fromDateValid }">*</span>
      </div>
      <div class="cell small-6 medium-2 large-2">
        <common-date-picker [id]="'fromDate'" [formGroup]="form?.get('fromDate')" [daysFuture]="0" (dateUpdated)="onDateUpdated($event)"></common-date-picker>
      </div>
      <div class="cell small-6 medium-2 large-2 text-align-right padding-right">
        To Date:<span class="bold" [ngClass]="{ 'red' : !toDateValid }">*</span>
      </div>
      <div class="cell small-6 medium-2 large-2">
        <common-date-picker [id]="'toDate'" [formGroup]="form?.get('toDate')" [daysFuture]="0" (dateUpdated)="onDateUpdated($event)"></common-date-picker>
      </div>
      <div class="cell small-12 medium-4 large-4">
        @if (fromDate == null) {
          <span class="red italic padding-left">From date is required.</span>
        }
        @if (toDate == null) {
          <span class="red italic padding-left">To date is required.</span>
        }
        @if (fromDate != null && toDate != null && form?.get('dateGreaterThan')?.invalid) {
          <span class="red italic padding-left">From date must be less than To date.</span>
        }
      </div>
    </div>
  </form>
</div>

<div class="grid-container margin-top extra-wide">
  <div class="grid-x">
    <div class="cell large-12 medium-12 small-12">
      @if (!flashing) {
        <ag-grid-angular class="data-grid  full-page" [gridOptions]="gridOptions" [rowData]="data | async" [excelStyles]="excelStyles" aria-label="User Permissions Report"></ag-grid-angular>
      } @else {
        Loading...
      }
    </div>
  </div>
</div>



